// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"118":"65a21e6e","344":"e832a3f7","439":"94fa22a7","453":"673ecc3d","644":"bfbddbf8","773":"a38392b9","809":"cded8d4f","880":"d94f2f9a","892":"4c30ce0d","979":"d927d6d2"}[chunkId] + ".chunk.js";
};